/* Shopify Ajax Cart + documented Zipify OCU drawer API. No checkout redirects. */
(() => {
  if (window.sfgA1CartBound) return;
  window.sfgA1CartBound = true;
  let adding = false;
  window.addEventListener('ocu:cart:loaded', () => { window.sfgA1OcuReady = true; });
  const add = async (event) => {
    if (event.type === 'click' && !event.target.closest('[data-sfg-cart] button[type="submit"]')) return;
    const form = event.target.closest('form[data-sfg-cart]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.dataset.sfgStatus = 'submitting';
    if (adding) return;
    const button = form.querySelector('button');
    const status = form.querySelector('[role="status"]');
    if (button.disabled) return;
    adding = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      const endpoint = new URL(form.action);
      endpoint.pathname = endpoint.pathname.replace(/\.js$/, '') + '.js';
      // Gift apps intercept string routes; URL objects can bypass their cart hooks.
      const response = await fetch(endpoint.href, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: Number(form.elements.quantity.value) }] })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || form.dataset.error);
      form.dataset.sfgStatus = 'added';
      if (window.sfgA1OcuReady || window.Zipify?.Cart?.cart) {
        window.dispatchEvent(new Event('ocu:cart:open:updated'));
      } else {
        // The same Shopify cart remains usable if the drawer app is unavailable.
        window.location.assign(form.dataset.cartUrl);
      }
    } catch (error) {
      form.dataset.sfgStatus = 'error';
      status.textContent = error.message || form.dataset.error;
    } finally {
      adding = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
  window.sfgA1Add = add;
  // Theme editor: selecting a FAQ block opens it, and selecting a plan keeps it visible.
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target;
    if (root.matches('details')) root.open = true;
    root.querySelectorAll('details').forEach(el => { el.open = true; });
  });
})();
// Keep the existing help launcher clear of the mobile purchase controls.
(() => {
  let observer;
  function observeOffers() {
    observer?.disconnect();
    const visible = new Set();
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      document.body.classList.toggle('sfg-a1-offer-visible', visible.size > 0);
    }, { threshold: 0.05 });
    document.querySelectorAll('.sfg-a1 #offer, .sfg-a1 #offer2').forEach(el => observer.observe(el));
  }
  document.addEventListener('DOMContentLoaded', observeOffers);
  document.addEventListener('shopify:section:load', observeOffers);
})();
